var $4ff2bb25c0089ffb$exports = {};
$4ff2bb25c0089ffb$exports = {
  "Empty": "Tu\u0161\u010Dias"
};
export { $4ff2bb25c0089ffb$exports as default };